var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('stripe-pricing-table',{attrs:{"pricing-table-id":_vm.stripePricingTable,"publishable-key":_vm.stripePK,"customer-email":_vm.organizationData.organization.email,"client-reference-id":_vm.organizationData.organization.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }